var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Icon from "./icon.svg";
var Native = Icon;
var Web = function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 121.89 94.53" }),
    React.createElement("circle", { cx: "61.23", cy: "80.29", r: "14.24", stroke: "none" }),
    React.createElement("path", { d: "M95.27,46c-.22-.22-.44-.42-.66-.61L94,44.77a3.63,3.63,0,0,0-.35-.3A46.46,46.46,0,0,0,29.45,46l-2.06,2.07L24.54,50.9A8.94,8.94,0,0,0,37.18,63.54l4.92-4.92a28.69,28.69,0,0,1,40.52,0l3.55,3.44a8.87,8.87,0,0,0,15.11-6.29,8.67,8.67,0,0,0-2.58-6.24Z", stroke: "none" }),
    React.createElement("path", { d: "M119.52,28.38l-3-3s0,0,0,0L114.19,23A8.36,8.36,0,0,0,112.86,22,77.51,77.51,0,0,0,8.15,24.39c-.14.13-.3.22-.44.36L2.37,30.1A8.15,8.15,0,0,0,13.9,41.62l5.34-5.33.1-.12a61.19,61.19,0,0,1,84.45-.46L108,39.92a8.15,8.15,0,0,0,11.52-11.54Z", stroke: "none" }),
    React.createElement("line", { x1: "10.31", y1: "1.5", x2: "97.64", y2: "86.49", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "15" }))); };
export default { Native: Native, Web: Web };
